module.exports = __webpack_public_path__ + "static/media/modal-close.1d32cfc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/modal-close.svg
// module id = 812
// module chunks = 0